<template>
  <Sheet>
    <div
      class="flex w-full shrink-0 items-center px-[14px] py-[7px] font-secondary text-gray-800"
    >
      <div class="mr-2.5 size-9 shrink-0">
        <Thumbnail :type="thumbType" :src="imageUrl" />
      </div>
      <div v-truncate class="w-full">
        <div
          class="text-[17px] font-medium leading-[18px]"
          data-truncate-target
        >
          {{ item.fileName }}
        </div>
        <div class="flex items-center text-[13px] opacity-50">
          Archived on {{ formatTimestamp(item.archivedAt) }}
        </div>
      </div>
    </div>

    <div class="mt-[12.5px] h-px w-full shrink-0 bg-gray-800/10" />

    <Sheet.Body class="px-0!">
      <Sheet.MenuItem :icon="InfoIcon" @click="handleFileInfoClick">
        Copyright info
      </Sheet.MenuItem>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Sheet, Thumbnail, useSheet } from '@dacr/library'
import { InfoIcon } from '@dacr/icons'
import type { ArchivedFile } from '@/shared/graphql/legacy/generated'
import { applyAuthorizationToken } from '@/shared/utils/url'
import { formatTimestamp } from '@/shared/utils/datetime'
import { fileTypeToThumbnail } from '@/shared/utils/thumbnail'
import { openDialog, Dialog } from '@/shared/dialogs/dialog'

const props = defineProps<{
  item: ArchivedFile
}>()

const { close } = useSheet()

const imageUrl = computed(() =>
  props.item.imageUrl
    ? applyAuthorizationToken(props.item.imageUrl, [
        { key: 'width', value: 72 },
      ])
    : undefined
)

const thumbType = computed(() => fileTypeToThumbnail(props.item.type))

const handleFileInfoClick = () => {
  close()
  openDialog(Dialog.CopyrightInfo, {
    props: { file: props.item },
  })
}
</script>
